/*! Copyright (c) 2021, XAPPmedia */

export default function insertSorted<T>(array: T[], obj: T, comparer: (left: T, right: T) => number): T[] {
    if (!array.length) {
        array.push(obj);
        return array;
    }

    let leftIndex = 0;
    let rightIndex = array.length - 1;

    while ((rightIndex - leftIndex) > 0) {
        const left = array[leftIndex];
        const right = array[rightIndex];

        const compLeft = comparer(obj, left);

        if (compLeft === 0) {
            return array; // exist
        }

        if (compLeft < 0) {
            array.splice(leftIndex, 0, obj);
            return array;
        }

        const compRight = comparer(obj, right);

        if (compRight === 0) {
            return array; // exist
        }

        if (compRight > 0) {
            array.splice(rightIndex + 1, 0, obj);
            return array;
        }
        
        if (rightIndex - leftIndex <= 1) {
            break;
        }

        const centerIndex = Math.floor((leftIndex + rightIndex) / 2);
        const center = array[centerIndex];
        
        const comp = comparer(center, obj);
        if (comp <= 0) {
            leftIndex = centerIndex;
            continue;
        }
        if (comp >= 0) {
            rightIndex = centerIndex;
            continue;
        }
    }
    array.splice(leftIndex + 1, 0, obj);
    return array;
}